<div>
  <img class="popImage" *ngIf="imageUrl" src="{{imageUrl}}">
</div>
